/**
 * A query argument that may change while the page is open (a search term, a date): pass a getter
 * and the query follows it; pass a plain value when it never changes.
 */
export type MaybeGetter<T> = T | (() => T);

export function read<T>(value: MaybeGetter<T>): T {
  return typeof value === 'function' ? (value as () => T)() : value;
}
